import Skeleton from 'react-loading-skeleton'

const CrossSelSkeleton = () => {
  return (
    <div className="flex flex-col sm:flex-row gap-2 w-full max-w-[1280px] mx-auto mt-14 md:mt-20 p-4">
      <div className="w-full h-[50px] sm:h-[256px]">
        <Skeleton count={1} height="100%" />
      </div>
      <div className="w-full h-[146px] sm:h-[256px]">
        <Skeleton count={1} height="100%" />
      </div>
      <div className="w-full h-[146px] sm:h-[256px]">
        <Skeleton count={1} height="100%" />
      </div>
    </div>
  )
}

export default CrossSelSkeleton
